export const CATEGORIES = [
  { value: "waste_removal", label: "Affaldsfjernelse", emoji: "♻️", color: "emerald" },
  { value: "micro_move", label: "Småflytning", emoji: "📦", color: "blue" },
  { value: "furniture_disposal", label: "Møbelbortskaffelse", emoji: "🛋️", color: "amber" },
  { value: "appliance_removal", label: "Hvidevarer fjernes", emoji: "🔌", color: "rose" },
  { value: "general_hauling", label: "Generel transport", emoji: "🚚", color: "violet" },
];

export const CATEGORY_LABELS = Object.fromEntries(CATEGORIES.map(c => [c.value, c.label]));

export const SIZE_LABELS = {
  small: "Lille",
  medium: "Mellem",
  large: "Stor",
  extra_large: "Ekstra stor",
};

export const TIME_LABELS = {
  morning: "Morgen",
  afternoon: "Eftermiddag",
  evening: "Aften",
  flexible: "Fleksibelt",
};

export const STATUS_LABELS = {
  open: "Åben",
  pending_payment: "Afventer betaling",
  accepted: "Accepteret",
  in_progress: "I gang",
  awaiting_approval: "Afventer godkendelse",
  completed: "Afsluttet",
  disputed: "Tvist",
  cancelled: "Annulleret",
};

export const STATUS_COLORS = {
  open: "bg-emerald-50 text-emerald-700 border-emerald-200",
  pending_payment: "bg-amber-50 text-amber-700 border-amber-200",
  accepted: "bg-blue-50 text-blue-700 border-blue-200",
  in_progress: "bg-amber-50 text-amber-700 border-amber-200",
  awaiting_approval: "bg-violet-50 text-violet-700 border-violet-200",
  completed: "bg-slate-100 text-slate-700 border-slate-200",
  disputed: "bg-red-50 text-red-700 border-red-200",
  cancelled: "bg-red-50 text-red-700 border-red-200",
};
